import { sessionUrlFilterClassMap } from './sessionUrlFilterClassMap.mjs'

export function sessionUrlFilterFromJson(json) {
  if (!json || !json.type) return null
  const classConstructor = sessionUrlFilterClassMap[json.type]
  if (!classConstructor)
    throw new Error(`Unknown SessionUrlFilter type: ${json.type}`)
  return new classConstructor(json)
}
